(function(){
var T={};try{var tj=document.querySelector('[data-t]');if(tj)T=JSON.parse(tj.textContent)||{};}catch(x){T={};}
var AR=['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
function ar(n){var s=String(n),o='';for(var i=0;i<s.length;i++){o+=(s[i]>='0'&&s[i]<='9')?AR[+s[i]]:s[i];}return o;}
function money(c){c=Math.round(c);var w=Math.floor(c/100),f=c-w*100;if(!f)return ar(w)+' ج.م';var d=f%10===0?String(f/10):(f<10?'0'+f:String(f));return ar(w)+'٫'+ar(d)+' ج.م';}
function esc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
var pdp=document.querySelector('[data-pdp]');
if(!pdp)return;
function shift(wrap,el,center,smooth){
if(!wrap||!el)return;
var r=el.getBoundingClientRect(),c=wrap.getBoundingClientRect();
if(!c.width)return;
var d=center?(r.left+r.width/2)-(c.left+c.width/2):(r.left-c.left);
if(Math.abs(d)<1)return;
try{wrap.scrollTo({left:wrap.scrollLeft+d,behavior:smooth?'smooth':'auto'});}catch(e){wrap.scrollLeft+=d;}
}
function idxOf(wrap){var w=wrap.clientWidth||1;return Math.round(Math.abs(wrap.scrollLeft)/w);}
var track=pdp.querySelector('[data-track]');
var slides=track?Array.prototype.slice.call(track.querySelectorAll('.slide')):[];
var thumbWrap=pdp.querySelector('.thumbs');
var thumbs=Array.prototype.slice.call(pdp.querySelectorAll('[data-idx]'));
var dots=pdp.querySelector('[data-dots]');
var prev=pdp.querySelector('[data-prev]');
var next=pdp.querySelector('[data-next]');
var active=0,raf=null,hold=0;
function setActive(i){
if(i<0||i>=slides.length)return;
active=i;
for(var k=0;k<thumbs.length;k++){var on=k===i;thumbs[k].classList.toggle('on',on);thumbs[k].setAttribute('aria-pressed',on?'true':'false');}
if(thumbs[i])shift(thumbWrap,thumbs[i],true,true);
if(dots){for(var d=0;d<dots.children.length;d++){dots.children[d].classList.toggle('on',d===i);}}
if(prev)prev.disabled=(i===0);
if(next)next.disabled=(i===slides.length-1);
}
function sync(){if(!track)return;var j=idxOf(track);if(j!==active&&j>=0&&j<slides.length)setActive(j);}
function goTo(i,smooth){
if(!slides[i])return;
hold=Date.now()+700;
shift(track,slides[i],false,smooth!==false);
setActive(i);
setTimeout(sync,750);
}
if(track&&slides.length>1){
if(dots){dots.innerHTML='';for(var q=0;q<slides.length;q++){var dot=document.createElement('i');if(q===0)dot.className='on';dots.appendChild(dot);}}
track.addEventListener('scroll',function(){
if(raf)return;
raf=requestAnimationFrame(function(){raf=null;if(Date.now()<hold)return;sync();});
},{passive:true});
track.addEventListener('scrollend',function(){hold=0;sync();});
track.setAttribute('tabindex','0');
track.addEventListener('keydown',function(e){
var rtl=document.documentElement.dir==='rtl';
if(e.key==='ArrowLeft'){e.preventDefault();goTo(rtl?active+1:active-1);}
if(e.key==='ArrowRight'){e.preventDefault();goTo(rtl?active-1:active+1);}
if(e.key==='Home'){e.preventDefault();goTo(0);}
if(e.key==='End'){e.preventDefault();goTo(slides.length-1);}
});
setActive(0);
}else{
if(prev)prev.style.display='none';
if(next)next.style.display='none';
}
var lb=document.querySelector('[data-lb]');
var lbt=lb?lb.querySelector('[data-lbtrack]'):null;
var lbs=lbt?Array.prototype.slice.call(lbt.children):[];
var lbc=lb?lb.querySelector('[data-lbc]'):null;
var lbx=lb?lb.querySelector('[data-lb-close]'):null;
var lbi=0,lraf=null,lastF=null;
function lbIsOpen(){return lb&&lb.getAttribute('data-open')==='true';}
function lbCount(){if(lbc)lbc.textContent=ar(lbi+1)+' '+(T.of||'')+' '+ar(lbs.length);}
function lbLoad(i){for(var k=i-1;k<=i+1;k++){if(lbs[k]){var im=lbs[k].querySelector('img');if(im&&!im.getAttribute('src'))im.setAttribute('src',im.getAttribute('data-src'));}}}
function lbOpen(i){
if(!lb||!lbs.length)return;
lastF=document.activeElement;
lbi=Math.max(0,Math.min(i,lbs.length-1));
lbLoad(lbi);
lb.setAttribute('data-open','true');
lb.setAttribute('aria-hidden','false');
document.body.classList.add('locked');
if(window.hwOverlay)hwOverlay.open('lb',function(){lbClose(true);});
requestAnimationFrame(function(){shift(lbt,lbs[lbi],false,false);lbCount();});
if(lbx)setTimeout(function(){lbx.focus();},40);
}
function lbClose(fromPop){
if(!lbIsOpen())return;
lb.setAttribute('data-open','false');
lb.setAttribute('aria-hidden','true');
document.body.classList.remove('locked');
if(fromPop!==true&&window.hwOverlay)hwOverlay.close('lb');
if(slides.length>1&&lbi<slides.length)goTo(lbi,false);
if(lastF&&lastF.focus)lastF.focus();
}
function lbGo(i){if(!lbs[i])return;lbLoad(i);shift(lbt,lbs[i],false,true);}
if(lbt){lbt.addEventListener('scroll',function(){if(lraf)return;lraf=requestAnimationFrame(function(){lraf=null;var i=idxOf(lbt);if(i!==lbi&&i>=0&&i<lbs.length){lbi=i;lbLoad(i);lbCount();}});},{passive:true});}
var sizes=[];
var nl=pdp.querySelectorAll('[data-size]');
for(var a=0;a<nl.length;a++){sizes.push(nl[a]);}
var sizesBox=pdp.querySelector('[data-sizes]');
var optName=sizesBox?(sizesBox.getAttribute('data-opt')||''):'';
var priceEl=pdp.querySelector('[data-price]');
var cmpEl=pdp.querySelector('[data-compare]');
var offEl=pdp.querySelector('[data-off]');
var ctas=document.querySelectorAll('[data-cta]');
var ctal=pdp.querySelector('[data-ctal]');
var vid=pdp.querySelector('[data-vid]');
var qtyIn=pdp.querySelector('[data-qty]');
var qtyV=pdp.querySelector('[data-qv]');
var itemsIn=pdp.querySelector('[data-items]');
var meta=document.querySelector('[data-stickymeta]');
var metaInit=meta?meta.textContent:'';
var form=pdp.querySelector('[data-form]');
var submit=form?form.querySelector('button[type="submit"]'):null;
var mainLbl=pdp.querySelector('[data-mainlbl]');
var main1=mainLbl?mainLbl.textContent:'';
var bundle=pdp.querySelector('[data-bundle]');
var tiers=bundle?Array.prototype.slice.call(bundle.querySelectorAll('[data-tier]')):[];
var rowsEl=bundle?bundle.querySelector('[data-rows]'):null;
var bsum=bundle?bundle.querySelector('[data-bsum]'):null;
var L1=bundle?(bundle.getAttribute('data-l1')||''):'';
var L2=bundle?(bundle.getAttribute('data-l2')||''):'';
var L3=bundle?(bundle.getAttribute('data-l3')||''):'';
var PER=bundle?(bundle.getAttribute('data-per')||''):'';
var SV=bundle?(bundle.getAttribute('data-sv')||''):'';
var CHG=bundle?(bundle.getAttribute('data-chg')||''):'';
var CAP=bundle?(bundle.getAttribute('data-cap')||''):'';
var sbtn=document.querySelector('[data-buy]');
var mainBlk=mainLbl&&mainLbl.closest?mainLbl.closest('.blk'):null;
var justK=-1,enterT=null;
var V=null;try{var vj=document.querySelector('[data-vjson]');if(vj)V=JSON.parse(vj.textContent);}catch(x){V=null;}
var OPTS=V&&V.opts?V.opts:[];
var VV=V&&V.v?V.v:[];
var openK=-1;
var COLORS={'أسود':'#1c1c1c','أبيض':'#ffffff','أحمر':'#b3261e','وردي':'#e8a6b5','بينك':'#e8a6b5','موف':'#9b7bb0','بنفسجي':'#6b3f8f','كحلي':'#1f2a44','أزرق':'#2f5d9e','لبني':'#b8d4ea','رمادي':'#8a8a8a','بيج':'#d9c6a5','كريمي':'#f1e6cf','أخضر':'#4f7a4a','زيتي':'#6b6b3a','نبيتي':'#6d1f2c','بني':'#6b4a33','سماوي':'#8ec5e8','أصفر':'#e3c04a','برتقالي':'#e38b3a','black':'#1c1c1c','white':'#ffffff','offwhite':'#f4efe6','ivory':'#f3ecdc','cream':'#f1e6cf','beige':'#d9c6a5','nude':'#e3c3aa','camel':'#b8864f','khaki':'#b5a67a','brown':'#6b4a33','coffee':'#5a3d2b','grey':'#8a8a8a','gray':'#8a8a8a','charcoal':'#3c3c3f','navy':'#1f2a44','blue':'#2f5d9e','babyblue':'#b8d4ea','skyblue':'#8ec5e8','green':'#4f7a4a','olive':'#6b6b3a','mint':'#b9dcc8','red':'#b3261e','burgundy':'#6d1f2c','maroon':'#6d1f2c','wine':'#722f37','pink':'#e8a6b5','rose':'#d98d9c','blush':'#efc3c6','purple':'#6b3f8f','lilac':'#c3a6d4','lavender':'#c9b8e0','mauve':'#9b7bb0','yellow':'#e3c04a','mustard':'#c9a227','orange':'#e38b3a','peach':'#f2b89a','coral':'#e8826f','روز جولد':'#b76e79','روز':'#b76e79','rosegold':'#b76e79','بني كاروهات':'repeating-linear-gradient(45deg,#6b4a33 0 3px,#c8a27a 3px 6px)','كاروهات':'repeating-linear-gradient(45deg,#6b4a33 0 3px,#c8a27a 3px 6px)','plaid':'repeating-linear-gradient(45deg,#6b4a33 0 3px,#c8a27a 3px 6px)','فوشيا':'#c2185b','زهري':'#e8a6b5','أوف وايت':'#f4efe6','تركواز':'#2a9d8f','ذهبي':'#c9a227','فضي':'#c0c0c0','موكا':'#6f4e37','كاميل':'#b8864f','منت':'#b9dcc8'};
function isColorOpt(n){return /لون|color|colour/i.test(n||'');}
function swatch(val){var c=COLORS[val]||COLORS[String(val).toLowerCase().replace(/[\s_-]/g,'')]||'';if(!c){var l=String(val).toLowerCase();if(window.CSS&&CSS.supports&&CSS.supports('color',l))c=l;}return c?'<span class="swd" style="background:'+esc(c)+'"></span>':'';}
function valuesOf(oi){var out=[],seen={};for(var i=0;i<VV.length;i++){var v=VV[i].o[oi];if(v!=null&&!seen[v]){seen[v]=1;out.push(v);}}return out;}
function findVar(sel){for(var i=0;i<VV.length;i++){var ok=true;for(var j=0;j<sel.length;j++){if(VV[i].o[j]!==sel[j]){ok=false;break;}}if(ok)return i;}return -1;}
function anyAvail(oi,val){for(var i=0;i<VV.length;i++){if(VV[i].a&&VV[i].o[oi]===val)return true;}return false;}
var mosImg=pdp.querySelector('.mos .tile img');
function showVar(i,smooth){
var v=VV[i];if(!v)return;
if(v.m>=0&&slides[v.m]&&v.m!==active)goTo(v.m,smooth);
if(mosImg&&v.u&&mosImg.getAttribute('data-cur')!==v.u){mosImg.removeAttribute('srcset');mosImg.setAttribute('data-cur',v.u);mosImg.classList.remove('swap');void mosImg.offsetWidth;mosImg.src=v.u;mosImg.classList.add('swap');var tl=mosImg.closest('.tile');if(tl&&v.m>=0)tl.setAttribute('data-zoom',v.m);}
}
function getIdx(k){return k===0?cur:rows[k];}
function setIdx(k,i){if(k===0)cur=i;else rows[k]=i;}
function multiOpts(){var n=0;for(var i=0;i<OPTS.length;i++){if(valuesOf(i).length>1)n++;}return n;}
function pickFor(k,oi,val){var cx=getIdx(k);var sel=VV[cx]?VV[cx].o.slice():[];sel[oi]=val;var i=findVar(sel);if(i>=0&&VV[i].a)return i;for(var j=0;j<VV.length;j++){if(VV[j].a&&VV[j].o[oi]===val)return j;}return -1;}
var CI=-1;for(var ci=0;ci<OPTS.length;ci++){if(isColorOpt(OPTS[ci])){CI=ci;break;}}
if(CI>=0){for(var si=0;si<sizes.length;si++){if(VV[si]&&!sizes[si].querySelector('.swd')){var r1=sizes[si].querySelector('.r1')||sizes[si];r1.insertAdjacentHTML('afterbegin',swatch(VV[si].o[CI]));}}}
var bnote=pdp.querySelector('[data-bnote]');
var waA=pdp.querySelector('[data-waq]');
var WAQ=waA?(waA.getAttribute('data-waq')||''):'',WAH=waA?(waA.getAttribute('href')||'').split('?')[0]:'';
var base=priceEl?parseInt(priceEl.getAttribute('data-base')||'0',10):0;
var baseCmp=bundle?(parseInt(bundle.getAttribute('data-cmp')||'0',10)||0):0;
var RATE={1:0,2:0.10,3:0.15};
var cur=0,tier=1,rows=[],qty=1;
for(var i=0;i<sizes.length;i++){if(sizes[i].classList.contains('on')){cur=i;break;}}
function sp(i){return sizes[i]?(parseInt(sizes[i].getAttribute('data-price'),10)||0):base;}
function sc(i){return sizes[i]?(parseInt(sizes[i].getAttribute('data-compare'),10)||0):baseCmp;}
function topOf(i){var p1=sp(i),c1=sc(i);return c1>p1?c1:p1;}
function firstAvail(pref){if(sizes[pref]&&!sizes[pref].disabled)return pref;for(var i=0;i<sizes.length;i++){if(!sizes[i].disabled)return i;}return pref;}
function buildRows(){
if(!rowsEl)return;
if(mainBlk)mainBlk.hidden=tier>1&&VV.length>1;
if(VV.length<2||tier<2){rowsEl.innerHTML='';return;}
var h=CAP?'<div class="pcap">'+esc(CAP)+'</div>':'';
for(var k=0;k<tier;k++){
var ix=getIdx(k);
if(ix==null||!VV[ix]||!VV[ix].a){ix=firstAvail(cur);setIdx(k,ix);}
var sel=VV[ix].o,sum=[];
for(var s=0;s<sel.length;s++){if(valuesOf(s).length<2&&OPTS.length>1)continue;sum.push((isColorOpt(OPTS[s])?swatch(sel[s]):'')+esc(sel[s]));}
var open=openK===k,lbl=k===0?L1:(k===1?L2:L3);
h+='<div class="pc2'+(open?' open':'')+(justK===k?' just':'')+'" data-n="'+(k+1)+'"><button type="button" class="pch" data-ptoggle="'+k+'" aria-expanded="'+(open?'true':'false')+'"><span class="pnum">'+ar(k+1)+'</span><span class="pn">'+esc(lbl)+'</span><span class="psum">'+sum.join('<i>،</i> ')+'</span><span class="pchev">'+esc(CHG)+'</span></button>';
if(open){
h+='<div class="pbody">';
for(var oi=0;oi<OPTS.length;oi++){
var vals=valuesOf(oi);if(vals.length<2&&OPTS.length>1)continue;
var col=isColorOpt(OPTS[oi]);
h+='<div class="og"><div class="ogl">'+esc(OPTS[oi])+'</div><div class="sizes" role="radiogroup" aria-label="'+esc(OPTS[oi])+'">';
for(var vi=0;vi<vals.length;vi++){
var val=vals[vi],on=sel[oi]===val,test=sel.slice();test[oi]=val;
var ex=findVar(test),exact=ex>=0&&VV[ex].a,any=anyAvail(oi,val);
h+='<button type="button" role="radio" aria-checked="'+(on?'true':'false')+'" class="size'+(on?' on':'')+(!on&&!exact&&any?' alt':'')+'" data-pk="'+k+'" data-oi="'+oi+'" data-ov="'+esc(val)+'"'+(any?'':' disabled')+'>'+(col?swatch(val):'')+'<b>'+esc(val)+'</b></button>';
}
h+='</div></div>';
}
h+='</div>';
}
h+='</div>';
}
justK=-1;
rowsEl.innerHTML=h;
}
function render(){
var b=sizes[cur];
var pr=base,cp=baseCmp;
if(b){
for(var i=0;i<sizes.length;i++){sizes[i].classList.remove('on');sizes[i].setAttribute('aria-checked','false');}
b.classList.add('on');b.setAttribute('aria-checked','true');
pr=sp(cur);cp=sc(cur);
if(vid)vid.value=b.getAttribute('data-id');
if(submit)submit.disabled=b.disabled;
}
if(priceEl)priceEl.textContent=money(pr);
if(cmpEl&&offEl&&b){
if(cp>pr){cmpEl.textContent=money(cp);cmpEl.hidden=false;offEl.textContent=(T.save||'')+' '+ar(Math.round((cp-pr)*100/cp))+'٪';offEl.hidden=false;}
else{cmpEl.hidden=true;offEl.hidden=true;}
}
var list=[cur];
for(var k=1;k<tier;k++){list.push(sizes.length>1?rows[k]:cur);}
if(waA&&WAH){var wseen={},wc=[];for(var w=0;w<list.length;w++){var wv=VV[list[w]],wx=wv?(CI>=0?wv.o[CI]:(sizes[list[w]]?sizes[list[w]].getAttribute('data-title'):'')):'';if(wx&&!wseen[wx]){wseen[wx]=1;wc.push(wx);}}var wl=wc.length?((CI>=0?OPTS[CI]:optName)+' '+wc.join(' و')):'';waA.setAttribute('href',WAH+'?text='+encodeURIComponent(WAQ+(wl?'، '+wl:'')));}
var total=0,topTotal=0;
for(var j=0;j<list.length;j++){var mult=tier>1?1:qty;total+=sp(list[j])*mult;topTotal+=topOf(list[j])*mult;}
var final=Math.round(total*(1-(RATE[tier]||0)));
for(var t=0;t<ctas.length;t++){ctas[t].textContent=money(final);}
if(sbtn)sbtn.textContent=tier===3?(T.add3||''):(tier===2?(T.add2||''):(T.add1||''));
if(ctal)ctal.textContent=tier===3?(T.add3||''):(tier===2?(T.add2||''):(T.add1||''));
var c1=cp>pr?cp:pr;
for(var n=0;n<tiers.length;n++){
var tb=tiers[n],tn=parseInt(tb.getAttribute('data-tier'),10),ton=tn===tier;
tb.classList.toggle('on',ton);tb.setAttribute('aria-checked',ton?'true':'false');
var gross=c1*tn,net=Math.round(pr*tn*(1-(RATE[tn]||0))),per=Math.round(net/tn),save=Math.round(gross/100)*100-Math.round(net/100)*100;
var tp=tb.querySelector('[data-tp]'),ts=tb.querySelector('[data-ts]'),tu=tb.querySelector('[data-tu]'),tsv=tb.querySelector('[data-tsv]');
if(tp)tp.textContent=money(net);
if(ts){if(gross>net){ts.textContent=money(gross);ts.hidden=false;}else{ts.hidden=true;}}
if(tu)tu.textContent=money(per)+' '+PER;
if(tsv){if(tn>1&&save>0){tsv.textContent=SV+' '+money(save);tsv.hidden=false;}else{tsv.hidden=true;}}
}
if(mainLbl)mainLbl.textContent=tier>1?(L1+'، '+main1):main1;
if(bsum){
if(tier>1){bsum.innerHTML='<span>'+esc(T.before||'')+' <s>'+money(topTotal)+'</s></span><b>'+esc(T.saved||'')+' '+money(Math.round(topTotal/100)*100-Math.round(final/100)*100)+'</b>';bsum.hidden=false;}
else{bsum.hidden=true;bsum.innerHTML='';}
}
if(bnote)bnote.hidden=tier<2;
if(meta){
if(tier>1)meta.textContent=tier===3?(T.pieces3||''):(T.pieces2||'');
else if(b)meta.textContent=optName+' '+b.getAttribute('data-title');
else meta.textContent=metaInit;
}
if(qtyIn)qtyIn.value=tier>1?1:qty;
if(qtyV)qtyV.textContent=ar(qty);
if(itemsIn){
if(tier>1){
var map={},order=[];
for(var m=0;m<list.length;m++){var el=sizes[list[m]];var id=el?el.getAttribute('data-id'):(vid?vid.value:'');if(!id)continue;if(!map[id]){map[id]=0;order.push(id);}map[id]++;}
var arr=[];for(var o=0;o<order.length;o++){arr.push({id:order[o],quantity:map[order[o]]});}
itemsIn.value=JSON.stringify(arr);
}else{itemsIn.value='';}
}
}
document.addEventListener('click',function(e){
var tg=e.target;if(!tg||!tg.closest)return;
if(lbIsOpen()){
if(tg.closest('[data-lb-close]')||tg.classList.contains('lbslide')){e.preventDefault();lbClose();}
return;
}
var z=tg.closest('[data-zoom]');
if(z&&pdp.contains(z)&&lbs.length){e.preventDefault();lbOpen(parseInt(z.getAttribute('data-zoom'),10)||0);return;}
var th=tg.closest('[data-idx]');
if(th&&pdp.contains(th)){e.preventDefault();goTo(parseInt(th.getAttribute('data-idx'),10)||0);return;}
if(tg.closest('[data-prev]')){e.preventDefault();goTo(active-1);return;}
if(tg.closest('[data-next]')){e.preventDefault();goTo(active+1);return;}
var pt=tg.closest('[data-ptoggle]');
if(pt&&pdp.contains(pt)){var pk=parseInt(pt.getAttribute('data-ptoggle'),10);openK=openK===pk?-1:pk;buildRows();if(openK===pk)showVar(getIdx(pk));return;}
var po=tg.closest('[data-pk]');
if(po&&pdp.contains(po)&&!po.disabled){var k2=parseInt(po.getAttribute('data-pk'),10),ix=pickFor(k2,parseInt(po.getAttribute('data-oi'),10),po.getAttribute('data-ov'));if(ix>=0){setIdx(k2,ix);justK=k2;showVar(ix);if(multiOpts()===1&&k2<tier-1)openK=k2+1;}buildRows();render();return;}
var tr=tg.closest('[data-tier]');
if(tr&&pdp.contains(tr)){var nt=parseInt(tr.getAttribute('data-tier'),10)||1;if(nt>tier)openK=nt-1;else if(openK>=nt)openK=-1;tier=nt;buildRows();render();if(rowsEl){rowsEl.classList.remove('enter');void rowsEl.offsetWidth;rowsEl.classList.add('enter');clearTimeout(enterT);enterT=setTimeout(function(){rowsEl.classList.remove('enter');},600);}return;}
var s=tg.closest('[data-size]');
if(s&&pdp.contains(s)&&!s.disabled){cur=sizes.indexOf(s);render();showVar(cur);return;}
var q=tg.closest('[data-q]');
if(q&&pdp.contains(q)){qty=Math.min(10,Math.max(1,qty+parseInt(q.getAttribute('data-q'),10)));render();return;}
var buy=tg.closest('[data-buy]');
if(buy&&form&&!(submit&&submit.disabled)){if(form.requestSubmit){form.requestSubmit();}else{form.submit();}}
});
document.addEventListener('keydown',function(e){
if(!lbIsOpen())return;
var rtl=document.documentElement.dir==='rtl';
if(e.key==='Escape'){e.preventDefault();lbClose();}
if(e.key==='ArrowLeft'){e.preventDefault();lbGo(rtl?lbi+1:lbi-1);}
if(e.key==='ArrowRight'){e.preventDefault();lbGo(rtl?lbi-1:lbi+1);}
});
buildRows();
render();
requestAnimationFrame(function(){var v=VV[cur];if(v&&v.m>0&&slides[v.m]){shift(track,slides[v.m],false,false);setActive(v.m);}});
})();
